// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".a0b6d705586c2eebeeac2b0ed69ae4706a14cbb7.chunk.js";
};